import React from 'react';
import { Col } from 'react-bootstrap';
import cx from 'classnames';
import TimeAgo from 'react-timeago';

import styles from './styles.module.scss';
import Text from 'src/components/text';
import { round } from 'lodash';

type CellType = 'deal_name' | 'amount' | 'health_score' | 'owner' | 'external_updated_at';

interface TableCellProps {
    col: number;
    type?: CellType;
    value?: any;
    classnames?: string;
    showArrow?: boolean;
    predictionTrend?: 'up' | 'down';
}

const DefaultUserAvatar = '/images/default_user_profile_background.png';


const Profile: React.FC<{ ownerName: string }> = ({ ownerName }) => {

    if (!ownerName) return <p>-</p>;

    return (
        <div className={styles.profile}>
            <img src={DefaultUserAvatar} className={styles.avatar} />
            <div className={styles.name}>
                <Text text={ownerName} tooltip={{ placement: "auto" }} />
            </div>
        </div>
    );
};

const TableCell: React.FC<TableCellProps> = ({ col, type, value, classnames, showArrow = false, predictionTrend }) => {

    const renderContent = () => {
        switch (type) {
            case 'deal_name':
                return (
                    <div className={styles.dealName}>
                        <Text text={value} tooltip={{ placement: "auto" }} />
                    </div>
                );
            case 'amount':
                return (
                    <p className={styles.value}>
                        ${value}
                    </p>
                );
            case 'health_score': {
                return (
                    <p className={cx(styles.prediction, { [styles.up]: value >= 60, [styles.down]: value < 30, [styles.medium]: value >= 30 && value < 60 })}>
                        <i className={cx( value >= 60 ? 'paperflite-up-arrow' : 'paperflite-dropdown', styles.icon)} />
                        {round(value)}%
                    </p>
                );
            }
            case 'owner':
                return <Profile ownerName={value} />;
            case 'external_updated_at':
                return (
                    <p className={styles.activityText}>
                        <TimeAgo date={value} live={false} />
                    </p>
                );
            default:
                return null;
        }
    };

    return (
        <Col md={col} className={cx(styles.cellContainer, classnames)}>
            <div className={cx(styles.contentContainer)}>
                {value !== null && value !== undefined ? renderContent() : <p>-</p>}
            </div>
            {showArrow && <i className={cx('paperflite-right-arrow', styles.navArrow)} />}
        </Col>
    );
};

export default TableCell;
